
function ToggleDiv( { width, margin, children, flexDir } ) {
  const Styles = {
    container: {
      width: width,
      margin: margin,
      flexDirection: flexDir,
    },
  }
  return ( 
    <div style={Styles.container}>
      { children }
    </div>
   );
}

export default ToggleDiv;